import React from "react";
import { CircularProgress } from "@material-ui/core";

export const WidgetNoDataToDisplay = props => {
  return (
    <div
      style={{
        transform: "translate(-50%, -50%)",
        position: "absolute",
        top: "50%",
        left: "50%",
        fontSize: "small"
      }}
    >
      {props.draggable ? "" : "No data to display"}
    </div>
  );
};

export const WidgetServerError = props => {
  return (
    <div
      style={{
        transform: "translate(-50%, -50%)",
        position: "absolute",
        top: "50%",
        left: "50%",
        fontSize: "small"
      }}
    >
      {props.draggable ? "" : "Temporarily unavailable"}
    </div>
  );
};

export const WidgetLoading = () => {
  return (
    <div
      style={{
        transform: "translate(-50%, -50%)",
        position: "absolute",
        top: "50%",
        left: "50%"
      }}
    >
      <CircularProgress size={100} />
    </div>
  );
};
